/**
 * When #bundler-v3 has content, moves the size guide trigger below .product-variant-container.
 */
(function () {
  var slot = document.querySelector(".size-guide-bundler-slot[data-section-id]");
  if (!slot) return;

  var sectionId = slot.dataset.sectionId;
  var sectionRoot = document.getElementById("shopify-section-" + sectionId);
  if (!sectionRoot) return;

  var variantContainer = sectionRoot.querySelector(".product-variant-container");
  if (!variantContainer) return;

  var debounce;
  var domObserverAttached = false;
  var originalParent = null;

  function bundlerFilled() {
    var b = document.getElementById("bundler-v3");
    if (!b) return false;
    return b.children.length > 0 || b.innerHTML.trim().length > 0;
  }

  function firstSizeGuideWrap() {
    return variantContainer.querySelector(".ss-size-guide-container");
  }

  function sync() {
    var wrap = firstSizeGuideWrap();
    if (!wrap) return;

    if (!originalParent && wrap.parentElement && wrap.parentElement !== slot) {
      originalParent = wrap.parentElement;
    }

    if (bundlerFilled()) {
      if (wrap.parentElement !== slot) {
        slot.appendChild(wrap);
      }
      slot.hidden = false;
    } else {
      if (wrap.parentElement === slot) {
        if (originalParent) {
          originalParent.appendChild(wrap);
        } else {
          variantContainer.appendChild(wrap);
        }
      }
      slot.hidden = true;
    }
  }

  function scheduleSync() {
    clearTimeout(debounce);
    debounce = setTimeout(sync, 80);
  }

  function run() {
    sync();
    if (domObserverAttached) return;
    domObserverAttached = true;
    var mo = new MutationObserver(scheduleSync);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.detail || e.detail.sectionId !== sectionId) return;
    slot = document.querySelector(
      '.size-guide-bundler-slot[data-section-id="' + sectionId + '"]'
    );
    sectionRoot = document.getElementById("shopify-section-" + sectionId);
    variantContainer =
      sectionRoot && sectionRoot.querySelector(".product-variant-container");
    if (!slot || !variantContainer) return;
    sync();
  });
})();
